<template lang="html">
  <transition name="modal-fade">
    <div class="modal-background">

      <div id="add-new-address-div" class="container white-box col-sm-6 col-11" role="dialog">

          <header>
            <h5 id="new-address-headline" class="text-center">Vælg på kortet eller søg på sted eller adresse</h5>
            <div id="new-address-close-btn" role="button" aria-label="Gå tilbage" @click="$emit('close');" tabindex="0">
              <span class="material-icons grey-text" aria-hidden="true">close</span>
            </div>
          </header>

          <section>
            <div id="custom-address-map" aria-hidden="true" v-show="showMap"></div>

            <div id="new-address-input-wrap">
              <input v-model="inputValue" id="new-address-input" type="text" placeholder="Søg efter sted, vej eller adresse" aria-label="Søg efter sted, vej eller adresse" class="form-control" @focus="showMap = false;" @keyup="searchForAddress()" autocomplete="off"/>
              <span id="input-delete-icon" @click="clearInput();" tabindex="0" aria-label="Ryd input"><span class="material-icons grey-text" aria-hidden="true">close</span></span>
            </div>

            <div v-show="addressSearchData.length != 0" id="input-list-explain">
              <span style="margin: 0;">Vælg en adresse eller et sted på listen nedenfor.</span>
              <ul id="new-address-input-list">

                <template v-for="(item, index) in addressSearchData">
                  <CustomAddressChild :addressData="item" @addressSelected="checkAddressData"></CustomAddressChild>
                </template>

              </ul>
            </div>

            <input id="new-address-alias" type="text" placeholder="Navngiv denne adresse (Valgfrit)" aria-label="Navngiv denne adresse (Valgfrit)" class="form-control" @focus="showMap = false;" v-if="!addressLookup" v-model="addressAlias"/>

          	<div id="search-spinner" class="col-12 text-center" v-show="showSpinner" aria-hidden="true">
          		<img class="loader-img" alt="Odense Rundt logo" src="@/assets/img/loading-logo.png" />
          		<svg class="loader-circle">
          			<circle class="path" cx="45" cy="45" r="40" fill="none" stroke-width="2" stroke-miterlimit="10"/>
          		</svg>
          	</div>
          </section>

          <footer>
            <button class="btn dark-grey col-5" aria-label="Brug GPS til at fastsætte adresse" @click="lookUpAddressViaGps();">Brug GPS</button>
            <button class="btn col-5" aria-label="Gem adresse" :class="[addressFound ? 'blue' : 'grey']" @click="confirmChoice();">Gem adresse</button>
          </footer>

      </div>

    </div>
  </transition>
</template>

<script>
import Map from '@/assets/Map.js'
import SmartSearch from '@/assets/SmartSearch.js'
import DataManager from '@/assets/DataManager.js'
import DataFunctions from '@/assets/DataFunctions.js'
import CustomAddressChild from '@/components/customAddress/CustomAddressChild.vue'
import { getCoordinatesFromAdress } from '@/assets/adressToCoords';

export default {
  data() {
    return {
      inputValue: '',
      map: false,
      mapMarker: false,
      addressName: false,
      addressAlias: '',
      addressCoords: false,
      addressFound: false,
      showMap: true,
      showSpinner: false,
      addressSearchData: [],
      SmartSearch: false,
      timeout: false,
      tagList: false,
    }
  },
  props: {
    addressLookup: {
      default: false,
    }
  },
  components: {
    CustomAddressChild
  },
  created() {
    this.SmartSearch = SmartSearch;
    DataManager.getData([
      DataManager.tagList,
    ], (response) => {
      this.tagList = response[0].data;
    });
  },
  mounted() {
    this.$HelperFunctions.setScreenReaderFocus('new-address-headline');

    this.loadMap();
  },
  methods: {
    loadMap() {
      var zoomControl = (this.$DeviceCheck.isMobile) ? true : false;
  		this.map = new Map('custom-address-map', {addZoomControl: zoomControl, controlPosition: 'bottomright', addAttribution: true, startZoom: 14});

  		this.map.map.on('click', (e) => {
  			this.selectOnMap(e);
  		});
  		this.map.map.on('contextmenu', (e) => {
  			this.selectOnMap(e);
  		});
    },

  	searchForAddress(e) {
      if(this.inputValue.length <= 2) return;

  		this.addressFound = false;
      this.showSpinner = true;
  		clearTimeout(this.timeout);

  		if(this.inputValue == '') {
  			this.showSpinner = false;
  			return;
  		}

  		this.timeout = setTimeout(() => {
        var input = document.getElementById('new-address-input');
  			SmartSearch.searchAddresses(input, data => {
  				this.displaySearchResults(data);
  			}, () => {
  				this.showSpinner = false;
  			});
  		}, 1500);
  	},

  	displaySearchResults(data) {
      console.log(data);
      var temp = [];

  		for(var i in data) {
        if(data[i].lat == undefined || data[i].lng == undefined) {
          //console.log(data[i]);
        }
        data[i].type = ((data[i].type == 'item') ? this.tagList[parseInt(data[i].tagId)].name : data[i].type);
        temp.push(data[i]);
  		}
      this.addressSearchData = temp;
      this.showSpinner = false;
  	},
  	async checkAddressData(options) {
      console.log(options);
      this.showMap = true;
      this.addressSearchData = [];

  		if(options.tagId == undefined) {
        // If type is husnummer we can get coordinates
        if (options.type === 'husnummer') {
          const data = await getCoordinatesFromAdress(options.href);
          setTimeout(() => {
            this.updateAddressValues(options.name, data.lat, data.lng);
          }, 500);        
        } else if (options.type === 'navngivenvejpostnummer') {
          // Type where we just have a roadname, which cannot provide a coordinate set in the new dawa API
          this.inputValue = options.name;
          this.searchForAddress();
        }
  		}
  		else {
        if(options.lat == undefined || options.lng == undefined) {
    			DataFunctions.getFeatureById(options.tagId, options.placeId).then((item) => {
            if(item == false) {
      				return '';
      			}
      			var coords = this.$HelperFunctions.findFirstCoords(item);
      			if(coords == false) {
      				return '';
      			}
      			coords = this.$HelperFunctions.resetCoords(coords);
      			options.lat = coords[1];
      			options.lng = coords[0];
            this.updateAddressValues(options.name, options.lat, options.lng);
          });
    		}
        else {
          setTimeout(() => {
    				this.updateAddressValues(options.name, options.lat, options.lng);
    			}, 500);
        }
  		}
  	},

    clearInput() {
      document.getElementById('new-address-input').value = '';
      this.showMap = true;
      this.addressSearchData = [];
    },

  	selectOnMap(e) {
  		var lat = parseFloat(e.latlng.lat);
  		var lng = parseFloat(e.latlng.lng);

      let addressName = 'Koordinater: ' +  lat.toFixed(5)+','+lng.toFixed(5);
      this.updateAddressValues(addressName, lat, lng);

      // axios.get('https://dawa.aws.dk/adgangsadresser/reverse?x='+e.latlng.lng+'&y='+e.latlng.lat)
      // .then((response) => {
      //   let addressName = response.data.vejstykke.navn+' '+response.data.husnr+', '+response.data.postnummer.nr+' '+response.data.postnummer.navn;
  		// 	this.updateAddressValues(addressName, lat, lng);
      // })
      // .catch(function (error) {
      //   console.log(error);
      // });
  	},

  	lookUpAddressViaGps() {
  		navigator.geolocation.getCurrentPosition((position) => {
  			this.lookUpAddressViaGpsSucces(position);
  		},
  		function(error) {
  			console.log(error);
  		});
  	},

  	lookUpAddressViaGpsSucces(position) {
  		console.log(position);
			var lat = position.coords.latitude;
			var lng = position.coords.longitude;

      let addressName = 'Koordinater: ' +  lat.toFixed(5)+','+lng.toFixed(5);
      this.updateAddressValues(addressName, lat, lng);

      // axios.get('https://dawa.aws.dk/adgangsadresser/reverse?x='+position.coords.longitude+'&y='+position.coords.latitude)
      // .then((response) => {
      //   let addressName = data.vejstykke.navn+' '+data.husnr+', '+data.postnummer.nr+' '+data.postnummer.navn;
  		// 	this.updateAddressValues(addressName, lat, lng);
      // })
      // .catch(function (error) {
      //   console.log(error);
      // });
  	},

  	updateAddressValues(name, lat, lng) {
  		document.getElementById('new-address-input').value = name;
      this.addressName = name;
      this.addressCoords = {
  			latitude: lat,
  			longitude: lng,
  		};

  		var markerHtml = '<div class="marker"><?xml version="1.0" encoding="utf-8"?>\
  			<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\
  				 viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">\
  			<style type="text/css">\
  				.st0{fill:none;}\
  			</style>\
  			<path class="st0" d="M0,0h48v48H0V0z"/>\
  			<path style="fill: #0096ce;" d="M22.7,4C14.4,4.6,7.5,10.7,5.6,18.8C3.2,28.9,10,37.6,18.7,40.6c0.9,0.3,1.7,0.9,2.2,1.6l3,3.8l3-3.8\
  				c0.6-0.7,1.4-1.3,2.3-1.6c7.5-2.5,13.6-9.4,13.6-17.7C42.9,12.1,33.7,3.3,22.7,4z"/>\
  			</svg>\
  			</div>';
  		var svgMarker = L.divIcon({className: 'svg-div-marker', iconAnchor: [22.5, 45], html: markerHtml});

  		if(this.mapMarker != false) {
  			this.map.map.removeLayer(this.mapMarker);
  		}
  		this.mapMarker = L.marker([this.addressCoords.latitude, this.addressCoords.longitude], {icon: svgMarker}).addTo(this.map.map);
  		this.map.map.flyTo([this.addressCoords.latitude, this.addressCoords.longitude]);

  		this.addressFound = true;
  	},

    confirmChoice() {
      if(this.addressFound) {
        this.submitNewAddress();
      }
      else {
        if(this.addressSearchData.length != 0) {
          alert('Vælg først en adresse eller et sted på listen.');
        }
        else {
          alert('Vælg på kortet eller søg via søgefeltet.');
        }
      }
    },

  	submitNewAddress() {
  		var object = {name: this.addressName, alias: this.addressAlias, coords: this.addressCoords};
			this.$emit('addressReady', object);
  	},
  }
}
</script>

<style lang="css" scoped>
#add-new-address-div {
  padding: 10px;
}

#new-address-close-btn {
  position: absolute;
  height: 30px;
  top: 4px;
  right: 5px;
  cursor: pointer;
}

#custom-address-map {
  height: 300px;
  border: 1px solid #eee;
}

#new-address-input, #new-address-alias {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
}

#new-address-alias {
  margin-top: 0px;
  margin-bottom: 0px;
}

#new-address-input-wrap {
  position: relative;
}

#input-delete-icon {
  position: absolute;
  display: block;
  top: 4px;
  right: 5px;
  width: 25px;
  height: 25px;
  cursor: pointer;
}

#input-delete-icon .material-icons {
  font-size: 25px !important;
}

#new-address-input-list {
  max-height: 300px;
  overflow-y: auto;
  margin-bottom: 10px;
}

#search-spinner {
	padding-top: 50px;
	padding-bottom: 50px;
}

footer {
  margin-top: 10px;
  text-align: center;
}

footer .btn:first-child {
  margin-right: 10px;
}

</style>
